// extracted by mini-css-extract-plugin
export var filterIncDec = "_by-0";
export var leftBorder = "_by-1";
export var rightBorder = "_by-2";
export var stringInput = "_by-3";